import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "utils/@reduxjs/toolkit";
import { AdminPriceState } from "../types/index";
import { initialState } from "./initialState";

export const sliceKey = "AdminPriceState";

export const adminPriceSlice = createSlice({
  name: sliceKey,
  initialState: initialState,
  reducers: {
    }})

export const { reducer, actions } = adminPriceSlice